const RAW_LOCATION_DATA = `Western,Colombo,Colombo
Western,Colombo,Dehiwala-Mount Lavinia
Western,Colombo,Moratuwa
Western,Colombo,Sri Jayawardenepura Kotte
Western,Colombo,Kaduwela
Western,Colombo,Battaramulla
Western,Colombo,Maharagama
Western,Colombo,Kesbewa
Western,Colombo,Homagama
Western,Colombo,Kolonnawa
Western,Colombo,Nugegoda
Western,Colombo,Piliyandala
Western,Colombo,Athurugiriya
Western,Colombo,Kottawa
Western,Colombo,Pannipitiya
Western,Colombo,Malabe
Western,Colombo,Rajagiriya
Western,Colombo,Nawala
Western,Colombo,Kohuwala
Western,Colombo,Wellawatta
Western,Colombo,Bambalapitiya
Western,Colombo,Borella
Western,Colombo,Narahenpita
Western,Colombo,Kirulapone
Western,Colombo,Mount Lavinia
Western,Colombo,Ratmalana
Western,Colombo,Angulana
Western,Colombo,Lunawa
Western,Colombo,Rawatawatta
Western,Colombo,Bokundara
Western,Colombo,Polgasowita
Western,Colombo,Makumbura
Western,Colombo,Hokandara
Western,Colombo,Udahamulla
Western,Colombo,Gangodawila
Western,Colombo,Boralesgamuwa
Western,Colombo,Pepiliyana
Western,Colombo,Nedimala
Western,Colombo,Navinna
Western,Colombo,Mirihana
Western,Colombo,Kotikawatta
Western,Colombo,Mulleriyawa
Western,Colombo,Thalawathugoda
Western,Colombo,Weliwita
Western,Colombo,Hanwella
Western,Colombo,Padukka
Western,Colombo,Angoda
Western,Colombo,Pamankada
Western,Colombo,Kahathuduwa
Western,Colombo,Gonapola
Western,Gampaha,Gampaha
Western,Gampaha,Negombo
Western,Gampaha,Katunayake
Western,Gampaha,Seeduwa
Western,Gampaha,Ja-Ela
Western,Gampaha,Wattala
Western,Gampaha,Kelaniya
Western,Gampaha,Kadawatha
Western,Gampaha,Ragama
Western,Gampaha,Kandana
Western,Gampaha,Minuwangoda
Western,Gampaha,Divulapitiya
Western,Gampaha,Mirigama
Western,Gampaha,Veyangoda
Western,Gampaha,Nittambuwa
Western,Gampaha,Kiribathgoda
Western,Gampaha,Udugampola
Western,Gampaha,Delgoda
Western,Gampaha,Pugoda
Western,Gampaha,Biyagama
Western,Gampaha,Ganemulla
Western,Gampaha,Yakkala
Western,Gampaha,Radawana
Western,Gampaha,Kirindiwela
Western,Gampaha,Dompe
Western,Kalutara,Kalutara
Western,Kalutara,Panadura
Western,Kalutara,Horana
Western,Kalutara,Beruwala
Western,Kalutara,Aluthgama
Western,Kalutara,Bandaragama
Western,Kalutara,Matugama
Western,Kalutara,Wadduwa
Western,Kalutara,Ingiriya
Western,Kalutara,Agalawatta
Western,Kalutara,Bulathsinhala
Western,Kalutara,Madurawela
Western,Kalutara,Dodangoda
Western,Kalutara,Millaniya
Western,Kalutara,Palindanuwara
Western,Kalutara,Kalutara South
Western,Kalutara,Kalutara North
Western,Kalutara,Nagoda
Western,Kalutara,Welipenna
Western,Kalutara,Maggona
Central,Kandy,Kandy
Central,Kandy,Peradeniya
Central,Kandy,Kundasale
Central,Kandy,Gampola
Central,Kandy,Nawalapitiya
Central,Kandy,Kadugannawa
Central,Kandy,Katugastota
Central,Kandy,Akurana
Central,Kandy,Ampitiya
Central,Kandy,Digana
Central,Kandy,Teldeniya
Central,Kandy,Pallekele
Central,Kandy,Pilimatalawa
Central,Kandy,Gelioya
Central,Kandy,Pussellawa
Central,Kandy,Ududumbara
Central,Kandy,Panvila
Central,Kandy,Pathadumbara
Central,Kandy,Udunuwara
Central,Kandy,Yatinuwara
Central,Kandy,Doluwa
Central,Kandy,Galagedara
Central,Kandy,Harispattuwa
Central,Kandy,Hatharaliyadda
Central,Kandy,Medadumbara
Central,Kandy,Minipe
Central,Kandy,Poojapitiya
Central,Kandy,Thumpane
Central,Kandy,Udapalatha
Central,Matale,Matale
Central,Matale,Dambulla
Central,Matale,Sigiriya
Central,Matale,Galewela
Central,Matale,Ukuwela
Central,Matale,Rattota
Central,Matale,Palapathwela
Central,Matale,Naula
Central,Matale,Yatawatta
Central,Matale,Ambanganga Korale
Central,Matale,Laggala-Pallegama
Central,Matale,Wilgamuwa
Central,Nuwara Eliya,Nuwara Eliya
Central,Nuwara Eliya,Hatton
Central,Nuwara Eliya,Talawakelle
Central,Nuwara Eliya,Maskeliya
Central,Nuwara Eliya,Ginigathena
Central,Nuwara Eliya,Kotagala
Central,Nuwara Eliya,Ragala
Central,Nuwara Eliya,Hanguranketha
Central,Nuwara Eliya,Walapane
Central,Nuwara Eliya,Ambewela
Central,Nuwara Eliya,Kotmale
Central,Nuwara Eliya,Nanu Oya
Central,Nuwara Eliya,Labookellie
Central,Nuwara Eliya,Ambagamuwa
Southern,Galle,Galle
Southern,Galle,Ambalangoda
Southern,Galle,Hikkaduwa
Southern,Galle,Elpitiya
Southern,Galle,Koggala
Southern,Galle,Ahangama
Southern,Galle,Karapitiya
Southern,Galle,Baddegama
Southern,Galle,Batapola
Southern,Galle,Habaraduwa
Southern,Galle,Unawatuna
Southern,Galle,Imaduwa
Southern,Galle,Bentota
Southern,Galle,Balapitiya
Southern,Galle,Yakkalamulla
Southern,Galle,Nagoda
Southern,Galle,Neluwa
Southern,Galle,Thawalama
Southern,Galle,Welivitiya-Divithura
Southern,Galle,Akmeemana
Southern,Galle,Bope-Poddala
Southern,Galle,Ginimellagaha
Southern,Galle,Gonapinuwala
Southern,Galle,Kadawathasathara
Southern,Galle,Karanndeniya
Southern,Galle,Niyagama
Southern,Matara,Matara
Southern,Matara,Weligama
Southern,Matara,Mirissa
Southern,Matara,Dickwella
Southern,Matara,Akuressa
Southern,Matara,Hakmana
Southern,Matara,Kamburupitiya
Southern,Matara,Deniyaya
Southern,Matara,Devinuwara
Southern,Matara,Gandara
Southern,Matara,Kekanadurra
Southern,Matara,Mulatiyana
Southern,Matara,Athuraliya
Southern,Matara,Kirinda Puhulwella
Southern,Matara,Kotapola
Southern,Matara,Malimbada
Southern,Matara,Pasgoda
Southern,Matara,Pitabeddara
Southern,Matara,Thihagoda
Southern,Matara,Welipitiya
Southern,Hambantota,Hambantota
Southern,Hambantota,Tangalle
Southern,Hambantota,Tissamaharama
Southern,Hambantota,Ambalantota
Southern,Hambantota,Beliatta
Southern,Hambantota,Weeraketiya
Southern,Hambantota,Middeniya
Southern,Hambantota,Sooriyawewa
Southern,Hambantota,Lunugamvehera
Southern,Hambantota,Katuwana
Southern,Hambantota,Angunakolapelessa
Southern,Hambantota,Walasmulla
Southern,Hambantota,Okewela
Northern,Jaffna,Jaffna
Northern,Jaffna,Chavakachcheri
Northern,Jaffna,Point Pedro
Northern,Jaffna,Nallur
Northern,Jaffna,Chankanai
Northern,Jaffna,Tellippalai
Northern,Jaffna,Manipay
Northern,Jaffna,Kopay
Northern,Jaffna,Sandilipay
Northern,Jaffna,Kokuvil
Northern,Jaffna,Karainagar
Northern,Jaffna,Velanai
Northern,Jaffna,Kayts
Northern,Jaffna,Delft
Northern,Jaffna,Vadamarachchi
Northern,Jaffna,Thenmarachchi
Northern,Jaffna,Valikamam
Northern,Kilinochchi,Kilinochchi
Northern,Kilinochchi,Pallai
Northern,Kilinochchi,Paranthan
Northern,Kilinochchi,Poonakary
Northern,Kilinochchi,Karachchi
Northern,Kilinochchi,Kandavalai
Northern,Mannar,Mannar
Northern,Mannar,Murunkan
Northern,Mannar,Nanattan
Northern,Mannar,Madhu
Northern,Mannar,Pesalai
Northern,Mannar,Thalaimannar
Northern,Mannar,Vankalai
Northern,Mannar,Adampan
Northern,Mannar,Erukkalampiddy
Northern,Mannar,Manthai West
Northern,Mannar,Musali
Northern,Mannar,Nanaddan
Northern,Mullaitivu,Mullaitivu
Northern,Mullaitivu,Oddusuddan
Northern,Mullaitivu,Puthukudiyiruppu
Northern,Mullaitivu,Maritimepattu
Northern,Mullaitivu,Welioya
Northern,Mullaitivu,Thunukkai
Northern,Mullaitivu,Manthai East
Northern,Vavuniya,Vavuniya
Northern,Vavuniya,Nedunkeni
Northern,Vavuniya,Settikulam
Northern,Vavuniya,Vavuniya South
Northern,Vavuniya,Vengalacheddikulam
Northern,Vavuniya,Omanthai
Northern,Vavuniya,Cheddikulam
Eastern,Trincomalee,Trincomalee
Eastern,Trincomalee,Kinniya
Eastern,Trincomalee,Mutur
Eastern,Trincomalee,Kuchchaveli
Eastern,Trincomalee,China Bay
Eastern,Trincomalee,Kantale
Eastern,Trincomalee,Gomarankadawala
Eastern,Trincomalee,Morawewa
Eastern,Trincomalee,Seruvila
Eastern,Trincomalee,Thampalakamam
Eastern,Trincomalee,Verugal
Eastern,Trincomalee,Nilaveli
Eastern,Trincomalee,Uppuveli
Eastern,Trincomalee,Padavi Siripura
Eastern,Trincomalee,Town & Gravets
Eastern,Batticaloa,Batticaloa
Eastern,Batticaloa,Kattankudy
Eastern,Batticaloa,Eravur
Eastern,Batticaloa,Kaluwanchikudy
Eastern,Batticaloa,Valachchenai
Eastern,Batticaloa,Chenkalady
Eastern,Batticaloa,Vakarai
Eastern,Batticaloa,Oddamavadi
Eastern,Batticaloa,Pasikudah
Eastern,Batticaloa,Kalkudah
Eastern,Batticaloa,Koralai Pattu
Eastern,Batticaloa,Manmunai
Eastern,Batticaloa,Porativu Pattu
Eastern,Ampara,Ampara
Eastern,Ampara,Kalmunai
Eastern,Ampara,Sainthamaruthu
Eastern,Ampara,Sammanthurai
Eastern,Ampara,Akkaraipattu
Eastern,Ampara,Nintavur
Eastern,Ampara,Addalachchenai
Eastern,Ampara,Thirukkovil
Eastern,Ampara,Pottuvil
Eastern,Ampara,Mahaoya
Eastern,Ampara,Uhana
Eastern,Ampara,Damana
Eastern,Ampara,Padiyathalawa
Eastern,Ampara,Arugam Bay
Eastern,Ampara,Panama
Eastern,Ampara,Lahugala
Eastern,Ampara,Dehiattakandiya
Eastern,Ampara,Eragama
Eastern,Ampara,Navithanveli
North Western,Kurunegala,Kurunegala
North Western,Kurunegala,Kuliyapitiya
North Western,Kurunegala,Narammala
North Western,Kurunegala,Wariyapola
North Western,Kurunegala,Pannala
North Western,Kurunegala,Melsiripura
North Western,Kurunegala,Mawathagama
North Western,Kurunegala,Nikaweratiya
North Western,Kurunegala,Polgahawela
North Western,Kurunegala,Alawwa
North Western,Kurunegala,Galgamuwa
North Western,Kurunegala,Giriulla
North Western,Kurunegala,Hettipola
North Western,Kurunegala,Bingiriya
North Western,Kurunegala,Ibbagamuwa
North Western,Kurunegala,Ambanpola
North Western,Kurunegala,Bamunakotuwa
North Western,Kurunegala,Ehetuwewa
North Western,Kurunegala,Ganewatta
North Western,Kurunegala,Giribawa
North Western,Kurunegala,Katupotha
North Western,Kurunegala,Kobeigane
North Western,Kurunegala,Kotavehera
North Western,Kurunegala,Mahawa
North Western,Kurunegala,Mallawapitiya
North Western,Kurunegala,Maspotha
North Western,Kurunegala,Panduwasnuwara
North Western,Kurunegala,Polpithigama
North Western,Kurunegala,Rasnayakapura
North Western,Kurunegala,Rideegama
North Western,Kurunegala,Udubaddawa
North Western,Kurunegala,Weerambugedara
North Western,Puttalam,Puttalam
North Western,Puttalam,Chilaw
North Western,Puttalam,Wennappuwa
North Western,Puttalam,Marawila
North Western,Puttalam,Nattandiya
North Western,Puttalam,Dankotuwa
North Western,Puttalam,Madampe
North Western,Puttalam,Anamaduwa
North Western,Puttalam,Kalpitiya
North Western,Puttalam,Palavi
North Western,Puttalam,Mundal
North Western,Puttalam,Madurankuliya
North Western,Puttalam,Arachchikattuwa
North Western,Puttalam,Karuwalagaswewa
North Western,Puttalam,Mahakumbukkadawala
North Western,Puttalam,Mahawewa
North Western,Puttalam,Nawagattegama
North Western,Puttalam,Pallama
North Western,Puttalam,Vanathavilluwa
North Central,Anuradhapura,Anuradhapura
North Central,Anuradhapura,Medawachchiya
North Central,Anuradhapura,Kekirawa
North Central,Anuradhapura,Tambuttegama
North Central,Anuradhapura,Eppawala
North Central,Anuradhapura,Talawa
North Central,Anuradhapura,Mihintale
North Central,Anuradhapura,Habarana
North Central,Anuradhapura,Galnewa
North Central,Anuradhapura,Galenbindunuwewa
North Central,Anuradhapura,Horowpothana
North Central,Anuradhapura,Kahatagasdigiliya
North Central,Anuradhapura,Kebithigollewa
North Central,Anuradhapura,Nochchiyagama
North Central,Anuradhapura,Padaviya
North Central,Anuradhapura,Palagala
North Central,Anuradhapura,Rajanganaya
North Central,Anuradhapura,Rambewa
North Central,Anuradhapura,Thirappane
North Central,Anuradhapura,Ipalogama
North Central,Anuradhapura,Mahavilachchiya
North Central,Anuradhapura,Nuwaragam Palatha
North Central,Polonnaruwa,Polonnaruwa
North Central,Polonnaruwa,Kaduruwela
North Central,Polonnaruwa,Medirigiriya
North Central,Polonnaruwa,Hingurakgoda
North Central,Polonnaruwa,Dimbulagala
North Central,Polonnaruwa,Elahera
North Central,Polonnaruwa,Jayanthipura
North Central,Polonnaruwa,Lankapura
North Central,Polonnaruwa,Manampitiya
North Central,Polonnaruwa,Welikanda
North Central,Polonnaruwa,Aralaganwila
North Central,Polonnaruwa,Thamankaduwa
Sabaragamuwa,Ratnapura,Ratnapura
Sabaragamuwa,Ratnapura,Embilipitiya
Sabaragamuwa,Ratnapura,Pelmadulla
Sabaragamuwa,Ratnapura,Kuruwita
Sabaragamuwa,Ratnapura,Balangoda
Sabaragamuwa,Ratnapura,Eheliyagoda
Sabaragamuwa,Ratnapura,Kalawana
Sabaragamuwa,Ratnapura,Nivitigala
Sabaragamuwa,Ratnapura,Kahawatta
Sabaragamuwa,Ratnapura,Godakawela
Sabaragamuwa,Ratnapura,Ayagama
Sabaragamuwa,Ratnapura,Kiriella
Sabaragamuwa,Ratnapura,Kolonna
Sabaragamuwa,Ratnapura,Panamure
Sabaragamuwa,Ratnapura,Rakwana
Sabaragamuwa,Ratnapura,Weligepola
Sabaragamuwa,Ratnapura,Imbulpe
Sabaragamuwa,Ratnapura,Kalthota
Sabaragamuwa,Ratnapura,Opanayake
Sabaragamuwa,Kegalle,Kegalle
Sabaragamuwa,Kegalle,Mawanella
Sabaragamuwa,Kegalle,Warakapola
Sabaragamuwa,Kegalle,Rambukkana
Sabaragamuwa,Kegalle,Galigamuwa
Sabaragamuwa,Kegalle,Dehiowita
Sabaragamuwa,Kegalle,Deraniyagala
Sabaragamuwa,Kegalle,Ruwanwella
Sabaragamuwa,Kegalle,Yatiyanthota
Sabaragamuwa,Kegalle,Bulathkohupitiya
Sabaragamuwa,Kegalle,Aranayake
Sabaragamuwa,Kegalle,Kitulgala
Uva,Badulla,Badulla
Uva,Badulla,Bandarawela
Uva,Badulla,Haputale
Uva,Badulla,Welimada
Uva,Badulla,Mahiyanganaya
Uva,Badulla,Passara
Uva,Badulla,Diyatalawa
Uva,Badulla,Ella
Uva,Badulla,Hali-Ela
Uva,Badulla,Haldummulla
Uva,Badulla,Beragala
Uva,Badulla,Kandaketiya
Uva,Badulla,Lunugala
Uva,Badulla,Meegahakivula
Uva,Badulla,Rideemaliyadda
Uva,Badulla,Soranathota
Uva,Badulla,Uraniya
Uva,Moneragala,Moneragala
Uva,Moneragala,Wellawaya
Uva,Moneragala,Buttala
Uva,Moneragala,Bibile
Uva,Moneragala,Kataragama
Uva,Moneragala,Siyambalanduwa
Uva,Moneragala,Medagama
Uva,Moneragala,Tanamalwila
Uva,Moneragala,Sevanagala
Uva,Moneragala,Madulla
Uva,Moneragala,Badalkumbura
Uva,Moneragala,Ethimale
Uva,Moneragala,Thanamalwila`;

type LocationRow = {
  province: string;
  district: string;
  city: string;
};

const LOCATION_ROWS: LocationRow[] = RAW_LOCATION_DATA.split('\n')
  .map((line) => {
    const [province, district, city] = line.split(',').map((part) => part?.trim() ?? '');
    return { province, district, city };
  })
  .filter((row) => row.province !== '' && row.district !== '' && row.city !== '');

function uniqueSorted(values: string[]): string[] {
  const map = new Map<string, string>();
  values.forEach((raw) => {
    const value = raw.trim();
    if (!value) return;
    const key = value.toLowerCase();
    if (!map.has(key)) map.set(key, value);
  });
  return Array.from(map.values()).sort((a, b) => a.localeCompare(b));
}

function parseAllLocations(): string[] {
  const provinces: string[] = [];
  const districts: string[] = [];
  const cities: string[] = [];

  LOCATION_ROWS.forEach((row) => {
    provinces.push(row.province);
    districts.push(row.district);
    cities.push(row.city);
  });

  return uniqueSorted([...cities, ...districts, ...provinces]);
}

export const ALL_LOCATIONS: string[] = parseAllLocations();

export type LocationDistrict = {
  name: string;
  cities: string[];
};

export type LocationProvince = {
  name: string;
  districts: LocationDistrict[];
};

function parseLocationHierarchy(): LocationProvince[] {
  const provinceMap = new Map<string, Map<string, Set<string>>>();

  LOCATION_ROWS.forEach((row) => {
    const provinceKey = row.province.toLowerCase();
    let districtMap = provinceMap.get(provinceKey);
    if (!districtMap) {
      districtMap = new Map<string, Set<string>>();
      provinceMap.set(provinceKey, districtMap);
    }

    const districtKey = row.district.toLowerCase();
    let citySet = districtMap.get(districtKey);
    if (!citySet) {
      citySet = new Set<string>();
      districtMap.set(districtKey, citySet);
    }

    citySet.add(row.city);
  });

  const provinces: LocationProvince[] = Array.from(provinceMap.entries())
    .map(([provinceKey, districtMap]) => {
      const provinceName = LOCATION_ROWS.find((row) => row.province.toLowerCase() === provinceKey)?.province ?? provinceKey;

      const districts: LocationDistrict[] = Array.from(districtMap.entries())
        .map(([districtKey, citySet]) => {
          const districtName = LOCATION_ROWS.find((row) => row.district.toLowerCase() === districtKey)?.district ?? districtKey;
          const cities = Array.from(citySet.values()).sort((a, b) => a.localeCompare(b));
          return { name: districtName, cities };
        })
        .sort((a, b) => a.name.localeCompare(b.name));

      return { name: provinceName, districts };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  return provinces;
}

export const LOCATION_HIERARCHY: LocationProvince[] = parseLocationHierarchy();

